import type { MenuItem } from '../config/layout/types';

/** Passed in `navigate` state when opening a case from the list so "Back" restores query filters. */
export type FlightChangeDetailLocationState = {
  flightCasesListReturnTo?: string;
};

export const ROUTES = {
  DASHBOARD: '/dashboard',
  FLIGHT_CHANGE_CASES: '/flight-change-cases',
  LOGIN: '/login',
  UNSUBSCRIBE: '/unsubscribe',
  UNSUBSCRIBE_THANK_YOU: '/unsubscribe/thank-you',
  FEEDBACK_THANK_YOU: '/feedback/thank-you',
} as const;

export const isMenuItemActive = (pathname: string, item: MenuItem): boolean =>
  pathname === item.path ||
  (item.path !== '/' && pathname.startsWith(item.path + '/')) ||
  (item.activePaths?.includes(pathname) ?? false);
